"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUpdateMarketingFreeSettingsRequestStatus = exports.getFetchMarketingFreeSettingsRequestStatus = void 0;

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var getFetchMarketingFreeSettingsRequestStatus = (0, _getRequestStatus.default)(_actions.MarketingFreeSettingsActionType.FETCH_MARKETING_FREE_SETTINGS);
exports.getFetchMarketingFreeSettingsRequestStatus = getFetchMarketingFreeSettingsRequestStatus;
var getUpdateMarketingFreeSettingsRequestStatus = (0, _getRequestStatus.default)(_actions.MarketingFreeSettingsActionType.UPDATE_MARKETING_FREE_SETTINGS);
exports.getUpdateMarketingFreeSettingsRequestStatus = getUpdateMarketingFreeSettingsRequestStatus;